import SearchIcon from "../icons/SearchIcon";

import styles from "../../styles/PillSearchInput.module.less";

type PillSearchInputProps = {
  value: string;
  onChange: (value: string) => void;
  onClear: () => void;
  placeholder?: string;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
};

const PillSearchInput = (props: PillSearchInputProps) => {
  const { value, onChange, onClear, placeholder, onKeyDown, onFocus } = props;

  return (
    <div className={styles.container}>
      <input
        value={value}
        className={styles.input}
        onChange={(e) => onChange(e.currentTarget.value)}
        placeholder={placeholder}
        onKeyDown={onKeyDown}
        onFocus={onFocus}
      />
      <SearchIcon className={styles.icon} isActive={!!value} onClick={onClear} />
    </div>
  );
};

export default PillSearchInput;
